const SecurityTab = () => {
  return <>Security tab</>;
};

export default SecurityTab;
